import { render } from "./App.vue?vue&type=template&id=50dd5c98"
const script = {}

import "./App.vue?vue&type=style&index=0&id=50dd5c98&lang=scss"

import exportComponent from "/Users/liushengjun/workspace/工具组件管理工具/uuus-management-tools-pages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__